export abstract class AvlCoordinateBase {
  abstract get lat(): number;
  abstract get lng(): number;
}
